import type { RequestParams } from '../requests/http-client';
import { ContentType, HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, EmptySuccessResponse, SendEventReq, SendEventTypeReq } from './data-contracts';


export default function useEvent() {
  class Event<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Event
     * @name EventControllerSendEvent
     * @summary Creates a raw event
     * @request POST:/cs2/event
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    eventControllerSendEvent = (data: SendEventReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/cs2/event',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Event
     * @name EventControllerSendUserEvent
     * @summary Creates a user event
     * @request POST:/cs2/event/user/{userId}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    eventControllerSendUserEvent = (userId: number, data: SendEventTypeReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/cs2/event/user/${userId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Event
     * @name EventControllerSendAdminEvent
     * @summary Creates an admin event
     * @request POST:/cs2/event/admin/{adminId}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    eventControllerSendAdminEvent = (adminId: number, data: SendEventTypeReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/cs2/event/admin/${adminId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Event();
}
